/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetPresentationService,
  IGetPresentationMethods,
  GetCostumeTypeService,
  IGetCostumeTypeMethods,
  CreateBoxService,
  ICreateBoxTypeMethods,
  ICreatePayFACMethods,
  CreatePayFACService,
  GetPreBookedAmtService,
  IGetPreBookedAmtMethods,
  IValidateDiscountMethods,
  ValidateDiscountService,
  IGetMyDiscountMethods,
  GetMyDiscountService,
  IMyProfileCardMethods,
  IUpdateBoxMethods,
  IGetCitiesMethods,
  GetCitiesService,
  UpdateBoxService,
  MyProfileCardService,
  AddToCartService,
  IAddToCartMethods,
  IdeleteCartMethods,
  IgetAllCartsMethods,
  deleteCartService,
  getAllCartsService,
  ICreateMultiBoxMethods,
  CreateMultiBoxService,
  ICreateMultiBoxCampMethods,
  CreateMultiBoxCampService,
} from "./components";
import {
  ITicketServiceMethods,
  TicketService,
} from "../costumePageService/components/ticket.service";

export type CostumeOpenRegPageAgent = IStaticPageContentMethods &
  IGetPresentationMethods &
  ICreatePayFACMethods &
  IGetCostumeTypeMethods &
  IGetPreBookedAmtMethods &
  ICreateBoxTypeMethods &
  IGetMyDiscountMethods &
  IMyProfileCardMethods &
  IdeleteCartMethods &
  IgetAllCartsMethods &
  IUpdateBoxMethods &
  IGetCitiesMethods &
  IValidateDiscountMethods &
  ICreateMultiBoxCampMethods &
  ICreateMultiBoxMethods &
  IAddToCartMethods &
  ITicketServiceMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetPresentationService(),
    new GetCostumeTypeService(),
    new CreateMultiBoxCampService(),
    new CreateMultiBoxService(),
    new CreateBoxService(),
    new deleteCartService(),
    new getAllCartsService(),
    new GetCitiesService(),
    new UpdateBoxService(),
    new MyProfileCardService(),
    new CreatePayFACService(),
    new GetPreBookedAmtService(),
    new ValidateDiscountService(),
    new GetMyDiscountService(),
    new AddToCartService(),
    new TicketService(),
  ];
};

export const getAgent = () => {
  return createAgent<CostumeOpenRegPageAgent>({
    plugins: getPlugins(),
  });
};
